import { LINKS, LOGIN_INFO, SUBSCRIBE_BUTTON_INFO } from './constants'
import styled, { keyframes } from 'styled-components'
import CloseButton from './CloseButton'
import MenuItemHamburguer from './MenuItemHamburguer'
import PropTypes from 'prop-types'
import React from 'react'
import TagLogo from './TagLogo'
import { useLocation } from '@reach/router'

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

const Backdrop = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: black;
  opacity: 0.5;
  height: 100vh;
  z-index: 5;
`

const FullMenuWrapper = styled.div`
  box-shadow: 0px 1px 4px rgba(19, 26, 45, 0.2);
  padding-top: 56px;
  font-family: "CircularStd";
  background: linear-gradient(90.11deg, rgb(8 11 19) 0%, rgb(0 8 37) 100%);
  display: flex;
  height: 100vh;
  padding-bottom: 40px;
  position: fixed;
  left: 0;
  top: 0;
  animation: ${fadeIn} .125s;
  width: 250px;
  z-index: 99999;

  li {
    font-family: 'Roboto Slab', serif;
    color: #fff;
    font-size: 16px;
    line-height: 40px;
    padding: 8px 0 8px 24px;
    display: flex;
    align-items: center;
    & > svg {
      margin-right: 8px;
    }
  }

  ul {
    width: 100%;

    div:first-child {
      margin-left: 16px;
    }

    div:last-child {
      bottom: 70px;
      position: absolute;
      width: 100%;
    }
  }

  p {
    height: 40px;
    width: auto;
    border-radius: 8px;
    color: rgb(255, 255, 255);
    text-align: center;
    font-size: 16px;
    line-height: 40px;
    font-weight: 700;
  }
`

const LoginButton = styled.p`
  margin-left: 16px;
  margin: 0 24px 16px;
  border: 1px solid rgb(255, 255, 255);
`

const CheckoutButton = styled.button`
  height: 40px;
  width: 202px;
  border-radius: 8px;
  color: rgb(255, 255, 255);
  text-align: center;
  font-size: 16px;
  line-height: 40px;
  font-weight: 700;
  background-color: #E16D00;
  margin: 0 24px;
  text-transform: uppercase;
`

const FullMenu = ( { onClickCloseButton, setShowSubscribeModal } ) => {
  const location = useLocation()
  const pageTextKey = location.pathname === '/' ? 'home' : 'remaining'

  return <>
    <FullMenuWrapper
      data-testid="full-menu"
      onClick={ onClickCloseButton }
    >
      <CloseButton
        data-testid="close-button"
        onClick={ onClickCloseButton }
      />
      <ul>
        <div>
          <TagLogo />
        </div>
        <div>
          { LINKS.map( ( { path, text, isExternal, icon } ) => (
            <MenuItemHamburguer
              href={ path }
              icon={ icon }
              isExternal={ isExternal }
              key={ path }
              text={ text }
            />
          ) ) }
        </div>
        <div>
          <a href={ LOGIN_INFO.path }>
            <LoginButton>{ LOGIN_INFO.text }</LoginButton>
          </a>
          <CheckoutButton
            onClick={ () => setShowSubscribeModal( true ) }
          >
            { SUBSCRIBE_BUTTON_INFO.text[ pageTextKey ] }
          </CheckoutButton>
        </div>
      </ul>
    </FullMenuWrapper>
    <Backdrop
      onClick={ onClickCloseButton }
    />
  </>
}

FullMenu.propTypes = {
  'onClickCloseButton': PropTypes.func.isRequired,
  'setShowSubscribeModal': PropTypes.func.isRequired,
}

export default FullMenu
